'use client';

import { useDebugValue, useEffect, useState } from 'react';

export function useScrollLock() {
  const [isLocked, setIsLocked] = useState(false);

  useDebugValue(isLocked ? 'Locked' : 'Unlocked');

  const lockScroll = () => {
    document.body.classList.add('overflowHidden');
    setIsLocked(true);
  };

  const unlockScroll = () => {
    document.body.classList.remove('overflowHidden');
    setIsLocked(false);
  };

  const toggleScrollLock = () => {
    if (isLocked) {
      unlockScroll();
    } else {
      lockScroll();
    }
  };

  useEffect(() => {
    return () => unlockScroll(); // Clean up on component unmount
  }, []);

  return { lockScroll, unlockScroll, toggleScrollLock, isLocked };
}
